<template>
  <div class="" id="home"> 
      <!------- HERO IMAGE SECTION -------->
      <Hero />
      <!------------ ABOUT SECTION--------->
      <About />
      <!------------ FEATURES ------------->
      <Features />
      <!---------- SIGN UP ---------------->
      <Impact />
       <!-------- IMPACT------------------->
      <SignUp />
      <!--------- FOOTER ------------------>
      <Footer />
</div>
</template>

<script>
import SignUp from '../components/SignUp'
import Hero from '../components/Hero'
import Footer from '../components/Footer'
import About from '../components/About'
import Features from '../components/Features'
import Impact from '../components/Impact'

export default {
  components: {
    Hero,
    Features,
    Footer,
    About,
    SignUp,
    Impact
  },

  created(){
    
  }
}
</script>

<style >
#home{
  height: 100%;
  width:100%;
}
#hero{
  position:sticky;
  top:0;
  z-index: 10;
  background-image: url('../assets/images/hero_image.jpg');
  width:100%;
  height: 100vh;
  overflow: hidden;
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.navbar-nav li a {
  font-weight: 600;
  float:right;
  text-align: left;
  color:#fff;
}
.fa-bars{
  color:rgb(255,128,57) ;
  font-size: 30px !important;
}
.navbar-toggler{
  outline:none;
}


/*--------------------- SIGN UP -----------------*/
#signUp{
  background-image: url('../assets/images/ft.jpg');
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  /* position:fixed; */
  width:100%;
  height: auto;
}
.signUp-inner{
  padding-top:100px;
  padding-bottom: 100px;
}
#signUp button {
  color:rgb(230, 91, 10);
  font-size:1.1em;
  padding:10px 20px;
}
::placeholder{
  color:#fff;
}
#signUp input{
  background-color: inherit;
  padding:30px !important;
  border:2px solid #fff;
  color:#fff !important;
}
::placeholder{
  color: #fff !important;
}
input:focus{
 outline: none;
 background-color: #fff;
}
/**-------------------------- media queries ------------ */
@media screen and (max-width:490px) {
  .hero-text h2{
   font-size: 3em;
  }
}
</style>